import AppDispatcher from '../dispatcher/app-dispatcher'
	

var LogActions = {
	message: function(message) {
		AppDispatcher.handleViewAction({
	      actionType: 'logMessage',
	      message: message
	    });
	}
};

export default LogActions;
